import React, { useState, useEffect } from 'react'

import { useParams, useHistory } from 'react-router-dom'

import Activity from '../../../../services/Activity'

import './styles.css'

function OperationsSection() {
  const [title, setTitle] = useState('')
  const [speaker, setSpeaker] = useState('')
  const [link, setLink] = useState('')
  const [description, setDescription] = useState('')
  const [hour, setHour] = useState('')
  const [date, setDate] = useState('')

  const { id } = useParams()
  const history = useHistory()

  useEffect(() => {
    if (id) {
      Activity.search(id).then(response => {
        setTitle(response.title)
        setSpeaker(response.speaker)
        setLink(response.link)
        setDescription(response.description)
        setHour(response.hour)
        setDate(response.date)

      }).catch(err => {
        alert('Erro ao processar requisição')
        console.log('ErrorName: ' + err.name + 'ErrorMessage: ' + err.message)
      })
    }
  }, [id])

  const update = () => {
    const toBeSaved = {
      title: title,
      speaker: speaker,
      link: link,
      description: description,
      hour: hour,
      date: date
    }

    Activity.update({ id, ...toBeSaved })
      .then(() => history.push('../'))
      .catch(err => {
        alert('Erro ao processar requisição')
        console.log('ErrorName: ' + err.name + 'ErrorMessage: ' + err.message)
      })
  }

  const create = () => {
    const toBeSaved = {
      title: title,
      speaker: speaker,
      link: link,
      description: description,
      hour: hour,
      date: date
    }

    Activity.create(toBeSaved)
      .then(() => history.push('../'))
      .catch(err => {
        alert('Erro ao processar requisição')
        console.log('ErrorName: ' + err.name + 'ErrorMessage: ' + err.message)
      })
  }

  const conclude = (e) => {
    e.preventDefault()

    if (id) {
      update()
    } else {
      create()
    }
  }

  return (
    <div id="operations-section">
      <h3 className="title-operations">{id ? 'Editar' : 'Cadastrar'}</h3>
      <form onSubmit={conclude}>
        <input
          type='text'
          className='input-operations'
          placeholder='Titulo'
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <input
          type='text'
          className='input-operations'
          placeholder='Palestrante'
          value={speaker}
          onChange={(e) => setSpeaker(e.target.value)}
        />
        <input
          type='text'
          className='input-operations'
          placeholder='Link'
          value={link}
          onChange={(e) => setLink(e.target.value)}
        />
        <textarea
          className='input-operations'
          placeholder='Descrição'
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <input
          type='time'
          className='input-operations'
          value={hour}
          onChange={(e) => setHour(e.target.value)}
        />
        <input
          type='date'
          className='input-operations'
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
        <button type="submit">Salvar</button>
      </form>
    </div>
  )
}

export default OperationsSection